import instance from './axiosInstance';
import type { OktaInfo } from 'pages/MyProfile/hooks';

export const getSelectedProfile = () => {
  return instance.get('/profiles?selected=true');
};

export const getUserFromOkta = async <T = OktaInfo>(
  userName: string,
  standAlone = false,
): Promise<T> => {
  const params = new URLSearchParams({
    ...(userName && { username: userName }),
    ...(standAlone && { standalone: 'true' }),
  });
  const res = await instance.get<T>(`/profiles/personal_info?${params.toString()}`);
  return res.data;
};

export const updateUserInOkta = async (formData: OktaInfo, email: string | undefined) => {
  const res = await instance.post('/profiles/personal_info', { profile: formData, email: email });
  return res.data;
};
